if (document.querySelector("#rt-pspr-form")) {
	void import("./front/productPage.js").then(({ productPage }) => {
		productPage();
	});
}
